module.exports = __webpack_public_path__ + "static/media/trimex_lidia.129f0807.png";